<div class="aufgaben-liste__kopf">
  <h3 class="aufgaben-liste__titel">{{ kopfKey() | translate }}</h3>
  @if (store.filter()) {
    <button type="button" class="aufgaben-liste__alle" (click)="store.filterAufheben()">
      {{ 'home.aufgaben.liste.alleZeigen' | translate }}
    </button>
  }
</div>

@if (store.status() === 'bereit') {
  @if (zeilen().length === 0) {
    <p class="aufgaben-liste__leer">
      <mat-icon aria-hidden="true">check</mat-icon>
      <span>{{ 'home.aufgaben.liste.leer' | translate }}</span>
    </p>
  } @else {
    <div class="aufgaben-liste__liste" tabindex="0" [attr.aria-label]="'home.aufgaben.liste.ariaListe' | translate">
      @for (zeile of zeilen(); track zeile.eintrag.id) {
        @let eintrag = zeile.eintrag;
        <div class="aufgaben-liste__zeile" data-testid="aufgabe-zeile">
          <span [class]="'aufgaben-liste__icon aufgaben-liste__icon--' + zeile.info.art">
            <mat-icon aria-hidden="true">{{ zeile.info.icon }}</mat-icon>
          </span>
          <div class="aufgaben-liste__text">
            <div class="aufgaben-liste__zeile1">
              <span class="aufgaben-liste__titel-zeile">{{ eintrag.title }}</span>
              @if (zeile.stufe) {
                <span [class]="'aufgaben-liste__badge aufgaben-liste__badge--' + zeile.stufe">
                  {{ 'home.aufgaben.liste.badge.' + zeile.stufe | translate }}
                </span>
              }
            </div>
            <div class="aufgaben-liste__zeile2">
              @if (eintrag.senderName) {
                <strong class="aufgaben-liste__absender">{{ eintrag.senderName }}</strong>
                <span>{{ trenner }}</span>
              }
              @if (eintrag.subtitle) {
                <span>{{ eintrag.subtitle + trenner }}</span>
              }
              <span>{{ 'home.aufgaben.liste.zeit.' + zeile.zeit.key | translate: { n: zeile.zeit.n } }}</span>
            </div>
          </div>
          <button
            type="button"
            class="aufgaben-liste__erledigt"
            data-testid="aufgabe-erledigt"
            [attr.title]="'home.aufgaben.liste.erledigt' | translate"
            [attr.aria-label]="'home.aufgaben.liste.erledigt' | translate"
            (click)="store.erledigen(eintrag)"
          >
            <mat-icon aria-hidden="true">check</mat-icon>
          </button>
          <button
            type="button"
            class="aufgaben-liste__aktion"
            data-testid="aufgabe-aktion"
            [disabled]="oeffnet() === eintrag.id"
            (click)="ausfuehren(eintrag)"
          >
            {{ zeile.info.aktionKey | translate }}
          </button>
        </div>
      }
    </div>
  }
}
